import { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import $ from "jquery";
import Select from "react-select";
import { validated } from "react-custom-validation";
import { motion } from "framer-motion";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, isEmpty, uploadFile, removeFile } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs";
import { Save, Plus, Trash2, RotateCcw, BarChart3, Activity } from "lucide-react";
import Analytics from "./components/Analytics";
/* import ProbabilityAnalytics from "./components/ProbabilityAnalytics"; */
import { ProbabilityAudit } from "./components/ProbabilityAudit";
const module = "company";
const moduleName = "Scratch Card Prize Settings";
const modulePath = "/clientpanel/scratch";
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageloading: false,
      clientdata: {
        product_name: "test",
        action: "add",
      },
      loading: true,
      formpost: [],
      companyBonusType: "",
      companyScratchClaimCount: "",
      companyScratchVoucher: [],
      totalProbability: 0,
      error_msg: "",
      productList: [],
      productListOptions: [],
      companyDetail: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.loadproductList();
    var params = {
      url: apiUrl + module + "/getCompanySettings",
      type: "client",
    };
    this.setState({ pageloading: true });
    this.props.getDetailData(params);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0]?.message || "";
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", "Scratch card settings updated successfully", "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata) {
      this.setState({ companyDetail: nextProps.detaildata }, () => {
        var result = nextProps.detaildata[0].result;
        const companyScratchVoucher = result?.companyScratchVoucher ?? "";
        const companyScratchClaimCount = result?.companyScratchClaimCount ?? "";
        let totalProbability = 0;
        let companyScratchVoucher_ =
          companyScratchVoucher !== "" && companyScratchVoucher !== null
            ? JSON.parse(companyScratchVoucher)
            : [
                {
                  voucherID: "",
                  probability: "",
                  displayOrder: 1,
                  max_wins_per_window:"",
                  window_days:"",
                  cooldown_days:"",
                  min_spins_required:"",
                  image: "",
                  isActive: true,
                },
              ];
        companyScratchVoucher_.map((item) => {
          item.probability = item?.probability ?? "";
          item.displayOrder = item?.displayOrder ?? "";
          item.max_wins_per_window = item?.max_wins_per_window ?? "";
          item.window_days = item?.window_days ?? "";
          item.cooldown_days = item?.cooldown_days ?? "";
          item.min_spins_required = item?.min_spins_required ?? "";
          totalProbability += parseFloat(item.probability !== "" ? item.probability : 0);
          return item;
        });
        this.setState({
          companyScratchVoucher: companyScratchVoucher_,
          companyScratchClaimCount: companyScratchClaimCount,
          companyBonusType: result?.companyBonusType ?? "1",
          totalProbability: totalProbability,
        });
      });
    }
  }

  loadproductList() {
    this.setState({ pageloading: true });
    var urlShringTxt = `${apiUrl}products/dropdownlist?productType=7`;
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ productList: res.data.result, pageloading: false }, function () {
            var tempVal = "";
            this.productListOption(tempVal);
          });
        }
      })
      .catch(() => {
        this.setState({ pageloading: false });
      });
  }

  productListOption = (selectedId) => {
    var productList = this.state.productList;
    let productLstHtml = "";
    if (selectedId !== "" && selectedId !== null && selectedId !== undefined) {
      productLstHtml = productList.map((productlst) => {
        if (selectedId === productlst._id) {
          return {
            value: productlst._id,
            label: productlst.label,
          };
        } else {
          return "";
        }
      });
      return productLstHtml !== "" ? productLstHtml : "";
    } else {
      productLstHtml = productList.map((productlst) => {
        return { value: productlst._id, label: productlst.label };
      });
      this.setState({ productListOptions: productLstHtml });
    }
  };

  sateValChange = (field, value) => {
    if (field === "page") {
    }
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value, rowval) => {
    console.log(field, value, rowval, "rowvalrowvalrowval");
    if (field === "companyScratchClaimCount") {
      this.setState({ companyScratchClaimCount: value });
    } else {
      var companyScratchVoucher = this.state.companyScratchVoucher;
      if (field === "plus") {
        if (companyScratchVoucher.length < 8) {
          companyScratchVoucher.push({
            voucherID: "",
            probability: "",
            displayOrder: parseInt(companyScratchVoucher.length) + 1,
            max_wins_per_window:"",
            window_days:"",
            cooldown_days:"",
            min_spins_required:"",
            image: "",
            isActive: true,
          });
        } else {
          showAlert("Error", "Maximum 8 Voucher only allowed", "error", "No");
        }
      } else if (field === "minus") {
        companyScratchVoucher.splice(rowval, 1);
      } else {
        companyScratchVoucher[rowval][field] = value;
      }
      let totalProbability = 0;
      companyScratchVoucher.forEach((item) => {
        totalProbability += parseFloat(item.probability !== "" ? item.probability : 0);
      });
      this.setState({ companyScratchVoucher, totalProbability });
    }
  };

  // Generate random hex color
  getRandomColor = () => {
    return (
      "#" +
      Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, "0")
        .toUpperCase()
    );
  };

  handleSubmit = () => {
    let companyScratchVoucher_ = this.state.companyScratchVoucher;
    let error = false;
    let totalVoucher = 0;
    if (companyScratchVoucher_.length > 0) {
      companyScratchVoucher_.map((item) => {
        var voucherID = item.voucherID?.value ?? "";
        if (voucherID === "") {
          error = true;
          item.voucherID_error = "This field is required";
        } else {
          item.voucherID_error = "";
          totalVoucher++;
        }
        return item;
      });
    } else {
      error = true;
    }
    if (error === false) {
      if (totalVoucher >= 1) {
        let updateScratchVoucher = [];
        companyScratchVoucher_.map((item) => {
          updateScratchVoucher.push({
            voucherID: item.voucherID,
            probability: item.probability,
            displayOrder: item.displayOrder,
            max_wins_per_window:item.max_wins_per_window,
            window_days:item.window_days,
            cooldown_days:item.cooldown_days,
            min_spins_required:item.min_spins_required,
            image: item.image,
            isActive: item.isActive,
          });
          return "";
        });
        showLoader("submit_frm", "class");
        var postObject = {
          companyScratchVoucher: JSON.stringify(updateScratchVoucher),
          companyScratchClaimCount: this.state.companyScratchClaimCount,
        };
        var post_url = `${module}/updateSetting`;
        const method = "update";
        this.props.getFormPost(postObject, post_url, "client", method);
      } else {
        showAlert("Error", "Minumum 4 Voucher required", "error", "No");
      }
    } else {
      this.setState({ companyScratchVoucher: companyScratchVoucher_ });
    }
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"scratch"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end"></div>
                </div>
                <div className="card">
                  <br />
                  <Tabs defaultValue="prizes" className="w-full">
                    <TabsList className="grid w-full grid-cols-3">
                      <TabsTrigger value="prizes">Prize Management</TabsTrigger>
                      <TabsTrigger value="probability" className="flex items-center gap-2">
                        <Activity className="h-4 w-4" />
                        Probability Audit
                      </TabsTrigger>
                      <TabsTrigger value="analytics" className="flex items-center gap-2">
                        <BarChart3 className="h-4 w-4" />
                        Analytics & Settings
                      </TabsTrigger>
                    </TabsList>

                    <TabsContent value="prizes" className="space-y-6 p-4">
                      <PostForm
                        {...this.props}
                        fields={this.state.clientdata}
                        onChange={this.fieldChange}
                        onValid={this.handleSubmit}
                        companyScratchVoucher={this.state.companyScratchVoucher}
                        companyScratchClaimCount={this.state.companyScratchClaimCount}
                        totalProbability={this.state.totalProbability}
                        memberShipData={this.state.memberShipData}
                        productList={this.state.productList}
                        productListOptions={this.state.productListOptions}
                        productListOption={this.productListOption}
                        getRandomColor={this.getRandomColor.bind(this)}
                        sateValChange={this.sateValChange}
                        onInvalid={() => {
                          setTimeout(function () {
                            if ($("#modulefrm .is-invalid").length > 0) {
                              $("html, body").animate(
                                {
                                  scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                                },
                                500,
                              );
                            }
                          }, 500);
                        }}
                      />
                    </TabsContent>

                    <TabsContent value="probability" className="p-4">
                      <ProbabilityAudit prizeData={this.state.companyScratchVoucher} />
                    </TabsContent>

                    <TabsContent value="analytics" className="p-4">
                      <Analytics />
                    </TabsContent>
                  </Tabs>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { product_name } = props.fields;

  return {
    fields: ["product_name"],

    validations: {
      product_name: [[isEmpty, product_name]],
    },
  };
}

class PostForm extends Component {
  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeTierAct(name, incrt, value) {
    this.props.onChange(name, value, incrt);
  }
  handleChangeCheckbox(name, incrt, e) {
    const checked = e.target.checked;
    this.props.onChange(name, checked, incrt);
  }

  handlePlusMinusAct(actn, incrt) {
    this.props.onChange(actn, actn, incrt);
  }

  async uplaodFiles(rwInt) {
    this.props.sateValChange("btndisabled", true);
    showLoader("ImageDetails");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#iconImage");
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "scratchcard", "client", "epicpay");
    if (fileDetail.status === "ok") {
      this.handleChangeTierAct("image", rwInt, fileDetail.url);
    }
    hideLoader("ImageContainer");
    hideLoader("ImageDetails");
    $("#iconImage").val("");
    this.props.sateValChange("btndisabled", false);
  }

  ScratchRowView(fields, $field, onChange) {
    var productListOptions = this.props.productListOptions;
    var companyScratchVoucher = this.props.companyScratchVoucher;
    if (companyScratchVoucher !== undefined && companyScratchVoucher !== "" && Object.keys(companyScratchVoucher).length > 0) {
      var ScratchRowCount = Object.keys(companyScratchVoucher).length;
      const ScratchRowHtml = companyScratchVoucher.map((ScratchRow, rwInt) => {
        let rwIntCnt = rwInt + 1;
        let voucherID = ScratchRow?.voucherID ?? "";
        const voucherID_error = ScratchRow?.voucherID_error ?? "";
        const iconImg = ScratchRow?.image || "";
        return (
          <div className="row prize-card" key={rwInt}>
            <div class="prize-header">Prize #{rwIntCnt}</div>
            <div className={`col-md-4 reward_freeproduct_id ${voucherID_error !== "" ? "error-select" : ""}`}>
              <div className="form-floating form-floating-outline custm-select-box mb-4">
                <Select value={voucherID} placeholder={"Select Products"} onChange={this.handleChangeTierAct.bind(this, "voucherID", rwInt)} options={productListOptions} />
                <label className="select-box-label">Voucher</label>
                {voucherID_error !== "" && <span className="error">{voucherID_error}</span>}
              </div>
            </div>
            {/*  <div className="col-md-3">
              <div className="form-floating form-floating-outline mb-4">
                <div id="ImageContainer">
                  <div className="input-group" style={{height:'49px'}}>
                  <input
                    className="form-control"
                    type="file"
                    id="iconImage"
                    onChange={(event) => {
                      this.uplaodFiles(rwInt, event);
                      return false;
                    }}
                  />
                  {iconImg!='' &&
                  <span class="input-group-text cursor-pointer"><img src={iconImg} alt="icon" style={{width:'30px', height:'30px'}} /></span>
      }
                  </div>
                </div>
              </div>
            </div>   */}
            <div className="col-md-2">
              <div className="form-floating form-floating-outline mb-4">
                <input
                  type="text"
                  className="form-control"
                  name="probability"
                  value={ScratchRow?.probability ?? ""}
                  {...$field("probability", (e) => onChange("probability", e.target.value, rwInt))}
                />
                <label htmlFor="probability">Probability(%)</label>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-floating form-floating-outline mb-4">
                <input
                  type="text"
                  className="form-control"
                  name="displayOrder"
                  value={ScratchRow?.displayOrder ?? ""}
                  {...$field("displayOrder", (e) => onChange("displayOrder", e.target.value, rwInt))}
                />
                <label htmlFor="displayOrder">Sequence</label>
              </div>
            </div>
            <div className="col-md-1">
              <div className="form-floating form-floating-outline mt-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id={`isActive${rwInt}`}
                    defaultChecked={ScratchRow?.isActive ?? false}
                    onChange={this.handleChangeCheckbox.bind(this, "isActive", rwInt)}
                  />
                  <label class="form-check-label" for={`isActive${rwInt}`}>
                    {" "}
                    Active{" "}
                  </label>
                </div>
              </div>
            </div>
          
              <p className="text-xs font-display text-muted-foreground uppercase tracking-wider">
                Scarcity controls (leave empty for no limit)
              </p>
            <div className="col-md-3">
              <div className="form-floating form-floating-outline mb-4">
                <input
                  type="number"
                  className="form-control"
                  name="max_wins_per_window"
                  placeholder="No global cap"
                  value={ScratchRow?.max_wins_per_window ?? ""}
                  {...$field("max_wins_per_window", (e) => onChange("max_wins_per_window", e.target.value, rwInt))}
                />
                <label htmlFor="max_wins_per_window">Max wins per window</label>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-floating form-floating-outline mb-4">
                <input
                  type="number"
                  className="form-control"
                  name="window_days"
                  value={ScratchRow?.window_days ?? ""}
                  {...$field("window_days", (e) => onChange("window_days", e.target.value, rwInt))}
                />
                <label htmlFor="window_days">Window length (days)</label>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-floating form-floating-outline mb-4">
                <input
                  type="number"
                  className="form-control"
                  name="cooldown_days"
                  placeholder="No cooldown"
                  value={ScratchRow?.cooldown_days ?? ""}
                  {...$field("cooldown_days", (e) => onChange("cooldown_days", e.target.value, rwInt))}
                />
                <label htmlFor="cooldown_days">Per-user cooldown (days)</label>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-floating form-floating-outline mb-4">
                <input
                  type="number"
                  className="form-control"
                  name="min_spins_required"
                  placeholder="No cooldown"
                  value={ScratchRow?.min_spins_required ?? ""}
                  {...$field("min_spins_required", (e) => onChange("min_spins_required", e.target.value, rwInt))}
                />
                <label htmlFor="min_spins_required">Minimum total spins before eligible</label>
              </div>
               <p className="text-[11px] text-muted-foreground">
                  Prize won't trigger until this many total spins have occurred
                </p>
            </div>
            {ScratchRowCount.length >= 2 && (
              <div className="prize-card-remove" onClick={this.handlePlusMinusAct.bind(this, "minus", rwInt)}>
                <i className="fa fa-trash" aria-hidden="true"></i>
              </div>
            )}
          </div>
        );
      });

      return ScratchRowHtml;
    } else {
      return "";
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field } = this.props;
    const prizes = this.props.companyScratchVoucher;
    console.log(prizes, "prizesprizesprizesprizes");
    return (
      <form className="fv-plugins-bootstrap5 reward-setting-maindiv" id="modulefrm">
        <div className="card-body row g-3 pt-5">
          <div className="h-6 rounded-full overflow-hidden flex bg-muted">
            {prizes.length > 0
              ? prizes
                  .filter((p) => p.isActive)
                  .map((prize, i) => {
                    const colors = ["hsl(var(--primary))", "hsl(9, 91%, 37%)", "hsl(253, 50%, 55%)", "hsl(155, 60%, 50%)", "hsl(45, 90%, 60%)"];
                    console.log(prize.probability, "prize.probability");
                    return (
                      <motion.div
                        key={prize.id}
                        initial={{ width: 0 }}
                        animate={{ width: `${(prize.probability / Math.max(this.props.totalProbability, 1)) * 100}%` }}
                        transition={{ duration: 0.5, delay: i * 0.1 }}
                        className="h-full relative group cursor-help"
                        style={{ backgroundColor: colors[i % colors.length] }}
                        title={`${prize.voucherID.label}: ${prize.probability}%`}
                      >
                        <span className="absolute inset-0 flex items-center justify-center text-[10px] font-display font-bold text-primary-foreground">{prize.probability}%</span>
                      </motion.div>
                    );
                  })
              : ""}
          </div>
          <div className="col-md-2">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={"form-control"}
                name="companyScratchClaimCount"
                value={this.props.companyScratchClaimCount}
                {...$field("companyScratchClaimCount", (e) => onChange("companyScratchClaimCount", e.target.value))}
              />
              <label htmlFor="companyScratchClaimCount">
                Point Per Scratch<span className="error">*</span>
              </label>
            </div>
          </div>
          <div class="spinwheel-container">
            <div class="header">
              <div></div>
              <div class="actions">
                <span class="badge">Total Probability: {this.props.totalProbability}%</span>
                <button type="button" class="btn btn-dark" onClick={this.handlePlusMinusAct.bind(this, "plus", this.props.companyScratchVoucher.length - 1)}>
                  + Add Prize
                </button>
              </div>
            </div>
            {this.ScratchRowView(fields, $field, onChange)}
            {this.props.companyScratchVoucher.length >= 2 && (
              <div class="header">
                <div></div>
                <div class="actions">
                  <span class="badge">Total Probability: {this.props.totalProbability}%</span>
                  <button type="button" class="btn btn-dark" onClick={this.handlePlusMinusAct.bind(this, "plus", this.props.companyScratchVoucher.length - 1)}>
                    + Add Prize
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="row g-3">
          <div className="pt-1 pb-4 pr-2 text-end" style={{ paddingRight: "20px" }}>
            <button
              type="button"
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Save All Changes
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
